import React from "react";

import { Col, Container, Image, Row } from "react-bootstrap";

import i18n from "../../i18n";

const TechnologyScreen: React.FC = () => {
  const { t, language } = i18n;

  return (
    <Container
      fluid
      className="screenContainer p-5"
      style={{ backgroundColor: "var(--bg-light-color)" }}
    >
      <Container className="flexContainer">
        <Row>
          <Col className="order-2 order-lg-1 mt-4 mt-lg-0" lg={5} xs={12}>
            <div className="flexContainer">
              <Image
                rounded
                alt={t("_technology_screen.0.title")}
                className="technologyImage"
                src={`/images/technology/Pakville_Cycle_${language}.png`}
              />
            </div>
          </Col>

          <Col className="order-1 order-lg-2" lg={7} xs={12}>
            <div className="flexContainer installationContent technologyContent">
              <div className="d-flex flex-column flex-lg-row justify-content-between align-items-center w-100">
                <h2 style={{ color: "var(--info-color)" }}>
                  {t("_technology_screen.0.title")}
                </h2>
                <Image
                  alt="PakVille-Patent"
                  src="/images/PakVille_Patent_pending_badge.png"
                  style={{ maxWidth: "160px" }}
                />
              </div>
              <p>{t("_technology_screen.0.description")}</p>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default TechnologyScreen;
